import React from 'react'

import type { Product } from '../../../../../../../__models__'
import type { ListingType } from '../../../../Product.types'
import { ExplanationText } from '../../../../components/ExplanationText/ExplanationText'
import { OnDemandListing } from './modules/OnDemandListing'

type OfferListingTypeProps = {
  product?: Product

  listingType?: ListingType
}

export const OfferListingType = ({ product, listingType }: OfferListingTypeProps) => {
  return (
    <>
      {listingType === 'YOU' && (
        <ExplanationText
          title="You handle shipping"
          subtitle="You're responsible for packing and shipping orders."
        />
      )}
      {listingType === 'ON_DEMAND' && !product && (
        <ExplanationText
          title="On demand"
          subtitle="This product is produced to order. Orders arrive within a few days of being placed."
        />
      )}
      {listingType === 'ON_DEMAND' && product && <OnDemandListing product={product} />}

      {listingType === 'DIGITAL' && (
        <ExplanationText
          title="Digital product"
          subtitle="Downloads will be emailed immediately upon purchase."
        />
      )}
      {listingType === 'WE' && (
        <ExplanationText
          title="We handle shipping"
          subtitle="We'll ship orders out within one business day of receiving them, as long as they are in stock."
        />
      )}
    </>
  )
}
